import './HowToSyncHeader.scss'
import { useTranslation } from 'react-i18next';

export default function HowToSyncHeader() {
    const { t } = useTranslation();
    return (
        <div className='hts-header__container'>
            <div className="hts-header__data">
                <div className='hts-header__title'>{t('settingsPage.howToSync.pageHeader')}</div>
                <div className='hts-header__sub-title'>{t('settingsPage.howToSync.pageSubHeader')}</div>
            </div>
        </div>
    )
}
